import Chart from 'chart.js'

let chart

export const pendenciasPraticasChart = {
  createChart (PendenciasPraticasChartID, result) {
    if (chart) {
      chart.destroy()
    }

    const labels = result.map(item => item.status)
    const quantidades = result.map(item => item.quantidades)

    let back = []

    const data = {
      labels: labels,
      datasets: [{
        label: 'Pendências',
        data: quantidades,
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgb(54, 162, 235)',
          'rgb(255, 205, 86)',
          'rgb(190, 37, 150)',
          'rgb(150, 190, 37)',
          'rgb(190, 77, 37)',
          'rgb(190, 169, 37)',
          'rgb(73, 190, 37)',
          'rgb(37, 86, 190)',
          'rgb(190, 37, 117)',
          'rgb(37, 190, 185)',
          'rgb(190, 180, 37)',
        ],
        hoverOffset: 4
      }]
    }

    const config = {
      type: 'pie',
      data: data,
    }

    chart = new Chart(
      document.getElementById(PendenciasPraticasChartID),
      config
    )
  },
}

const funcs = {
  PendenciasPraticasChartID () { }
}

export default funcs
